import { useInfiniteListWithRestore } from '../useInfiniteListWithRestore/useInfiniteListWithRestore';
import useMassActions from '../useMassActions/useMassActions';
import { useOnKeyChange } from '../useOnKeyChange';
import { UseInfiniteListWithCheckboxParams } from './useInfiniteListWithCheckbox.types';
import { UseInfiniteListWithCheckboxTransformers } from './utils/useInfiniteListWithCheckbox.transformers';

export const useInfiniteListWithCheckbox = <PageData>({
  limit,
  queryFn,
  cacheKey,
  isEnabled,
  queryFnParams,
  defaultOrderBy,
}: UseInfiniteListWithCheckboxParams<PageData>) => {
  const checkboxManager = useMassActions<string>();

  const { mutateMethods, query, restoreScrollOnMount } = useInfiniteListWithRestore<PageData>({
    limit,
    isEnabled,
    defaultOrderBy,
    queryFn: (context) => queryFn({ ...context, params: queryFnParams }),
    queryKey: ['infinite-list-with-checkbox', cacheKey, queryFnParams],
  });

  useOnKeyChange(
    UseInfiniteListWithCheckboxTransformers.toSelectionKey(query),
    checkboxManager.clearSelectedItems,
  );

  return {
    query,
    mutateMethods,
    checkboxManager,
    restoreScrollOnMount,
  };
};
